import React, { useState, useEffect, useMemo } from 'react';
import KeycloakService from '../../services/KeycloakService';
import {
  getEmployeesOnLeave,
  getUserData,
  getUserLeaves,
  getUserLeavesSummaryByYear,
  getUserManagers,
} from '../../services/UserService';
import { useSelector } from 'react-redux';
import Welcome from './Welcome/Welcome';
import TimingsDetail from './TimingsDetail/TimingsDetail';
import LeaveStatus from './LeaveStatus/LeaveStatus';
import PeopleOnLeave from './PeopleOnLeave';
import { useStyles } from './InternalStyle';
import { Box, Grid, Paper, Skeleton } from '@mui/material';
import { getLeaveStatus } from './TilesConstants';
import moment from 'moment';
import QuotaDetails from './QuotaDetails/QuotaDetails';
import WorkPayrollSummary from './WorkPayrollSummary/WorkPayrollSummary';
import { getLeaveTypeList } from '../../services/LeaveService';
import { getCasualLeaveAccounting } from '../../services/CasualLeaveAccountingService';
import {
  getEmployeeClientOfficeHoursQuota,
  getEmployeeExternalHoursQuota,
  getEmployeeWorkTravelHoursQuota,
  getEmployeeWfhQuota,
} from '../../admin/Services/EmployeePrivilegesService';
import {
  getDaysFromNumber,
  msToTime,
} from '../../utils/TimeConversionFunctions';
import { getSummary } from '../../services/TimingService';
import GenericLoader from '../Loader/GenericLoader';
import { TimesheetsComponentLoaderAttribute } from '../../constants';
import { getHolidays } from '../../admin/Services/MasterdataService';
import { getWFHTask } from '../../services/WFHService';
import { getRemoteOfficeHoursTasks } from '../../services/RemoteOfficeHoursService';

function Tiles() {
  const classes = useStyles();
  const people = useSelector((state) => state.peopleState);
  const currentUserId = () => KeycloakService.getUserDetail();
  const [loader, setLoader] = useState(true);
  const [userDetails, setUserDetails] = useState({});
  const [managerList, setManagerList] = useState([]);
  const [leaveStatus, setLeaveStatus] = useState([]);
  const [overallStatus, setOverallStatus] = useState('');
  const [leaveDate, setLeaveDate] = useState();
  const [employeesOnLeave, setEmployeesOnLeave] = useState([]);
  const [payrollLoader, setPayrollLoader] = useState(true);
  const [quotaLoader, setQuotaLoader] = useState(true);
  const [totalHours, setTotalHours] = useState(msToTime(0));
  const [officeHours, setOfficeHours] = useState(msToTime(0));
  const [externalHours, setExternalHours] = useState(msToTime(0));
  const [clientOfficeHours, setClientOfficeHours] = useState(msToTime(0));
  const [workTravelHours, setWorkTravelHours] = useState(msToTime(0));
  const [weekendWorkingHours, setWeekendWorkingHours] = useState(msToTime(0));
  const [wfhDays, setWfhDays] = useState('0 days');
  const [approvedWfhHours, setApprovedWfhHours] = useState(msToTime(0));
  const [reportedWfhHours, setReportedWfhHours] = useState(msToTime(0));
  const [pendingRemoteOfficeHours, setPendingRemoteOfficeHours] = useState(
    msToTime(0),
  );
  const [approvedRemoteOfficeHours, setApprovedRemoteOfficeHours] = useState(
    msToTime(0),
  );
  const [payrollPercentage, setPayrollPercentage] = useState('0');
  const [expectedHours, setExpectedHours] = useState(msToTime(0));
  const [filteredLeaveList, setFilteredLeaveList] = useState([]);
  const [casualLeaveAccounting, setCasualLeaveAccounting] = useState(null);
  const [wfhQuota, setWfhQuota] = useState([]);
  const [externalHoursQuota, setExternalHoursQuota] = useState([]);
  const [clientOfficeHoursQuota, setClientOfficeHoursQuota] = useState([]);
  const [workTravelHoursQuota, setWorkTravelHoursQuota] = useState([]);
  const [userAvailedLeaves, setUserAvailedLeaves] = useState([]);
  const dt = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1,
  ).toLocaleDateString('en-CA');
  const [startDate, setStartDate] = useState(
    new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
    ).toLocaleDateString('en-CA'),
  );
  const [endDate, setEndDate] = useState(
    startDate === dt
      ? new Date().toLocaleDateString('en-CA')
      : new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0,
        ).toLocaleDateString('en-CA'),
  );
  const [currentDate, setCurrentDate] = useState(moment().toDate());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const loadData = async () => {
    let user;
    let listOfLeaves;
    let employeesList;
    if (people.id === '' && currentUserId !== undefined) {
      user = await getUserData(currentUserId());
      if (user.isError === false) {
        setUserDetails(() => user.data);
        employeesList = await getEmployeesOnLeave(currentUserId());
        setEmployeesOnLeave(employeesList?.data);
        listOfLeaves = await getUserLeaves(currentUserId(), '');
      }
    } else {
      user = await getUserData(people.id);
      if (user.isError === false) {
        setUserDetails(() => user.data);
        employeesList = await getEmployeesOnLeave(currentUserId());
        setEmployeesOnLeave(employeesList.data);
        listOfLeaves = await getUserLeaves(people.id, '');
      }
    }
    if (
      listOfLeaves &&
      listOfLeaves.data &&
      listOfLeaves.data.data &&
      listOfLeaves.data.data.content &&
      listOfLeaves.data.data.content.length !== 0
    ) {
      const currentDate = new Date(new Date().setHours((0, 0, 0, 0)));
      let leave = listOfLeaves.data.data.content.filter(function (item) {
        return (
          (new Date(item.startDate) - currentDate >= 0 ||
            new Date(item.endDate) - currentDate >= 0) &&
          item.status !== 'REJECTED' &&
          item.type !== 'WFH' &&
          item.status !== 'CANCELLED'
        );
      });
      if (leave?.length !== 0) {
        leave.sort((obj1, obj2) =>
          obj1.startDate > obj2.startDate
            ? 1
            : obj1.startDate < obj2.startDate
              ? -1
              : 0,
        );
        generateObjectToDisp(leave[0].applicationStatusDTOS, leave[0]);
      }
    }
    setLoader(false);
  };

  const getApproverName = async (id, object) => {
    if (!id) {
      object.name = 'HR/Admin';
      return;
    }
    const name = await getUserData(id);
    if (name && name.data && name.data.firstName) {
      object.name = `${name.data.firstName || ''} ${name.data.lastName || ''}`.trim();
    } else {
      object.name = id.includes('@') ? id.split('@')[0].replace('.', ' ') : 'HR/Admin';
    }
  };

  const generateObjectToDisp = async (applicationDTO_array, leave) => {
    let managerList1 = [];
    let leaveStatus1 = [];
    await Promise.all(
      applicationDTO_array.map(async (obj) => {
        await getApproverName(obj.approverId, obj);
      }),
    );
    for (let i = 0; i < applicationDTO_array.length; i++) {
      managerList1[i] = applicationDTO_array[i].name;
      leaveStatus1[i] = getLeaveStatus(applicationDTO_array[i].status);
    }
    if (leave.startDate === leave.endDate) {
      setLeaveDate(moment(leave.startDate).format('MMM Do'));
    } else {
      setLeaveDate(
        `${moment(leave.startDate).format('MMM Do')} to ${moment(
          leave.endDate,
        ).format('MMM Do')}`,
      );
    }
    setOverallStatus(leave.status);
    setManagerList(managerList1);
    setLeaveStatus(leaveStatus1);
  };

  const getLeavesWfhSummary = useMemo(async () => {
    setQuotaLoader(true);

    const leaveSummary = await getUserLeavesSummaryByYear(
      currentUserId(),
      selectedYear,
    );
    const leaveList = await getLeaveTypeList(selectedYear);
    const employeeWFHQuota = await getEmployeeWfhQuota(
      selectedYear,
      currentUserId(),
    );
    const employeeExternalHoursQuota = await getEmployeeExternalHoursQuota(
      selectedYear,
      currentUserId(),
    );
    const employeeClientOfficeHoursQuota =
      await getEmployeeClientOfficeHoursQuota(selectedYear, currentUserId());
    const employeeWorkTravelHoursQuota = await getEmployeeWorkTravelHoursQuota(
      selectedYear,
      currentUserId(),
    );
    const casualLeaveAccountingResponse = await getCasualLeaveAccounting(
      currentUserId(),
      selectedYear,
    );
    if (
      leaveSummary.isError === false &&
      leaveList.isError === false &&
      employeeWFHQuota.isError === false &&
      employeeExternalHoursQuota.isError === false
    ) {
      const filteredLeaveList = leaveList.data
        .filter((leave) => leave.leaveCategoryId === 1)
        .map((leave) => {
          const leaveRecord = leaveSummary.data.data.leavesRecordDTOList.find(
            (record) => record.leaveId === leave.id,
          );
          return {
            leaveName: leave.leaveName,
            leaveCategoryId: leave.leaveCategoryId,
            ...leaveRecord,
          };
        })
        .filter((item) => item.leaveId);
      setFilteredLeaveList(filteredLeaveList);
      setCasualLeaveAccounting(
        casualLeaveAccountingResponse.isError === false
          ? casualLeaveAccountingResponse.data.data
          : null,
      );
      setWfhQuota(employeeWFHQuota.data.data);
      setExternalHoursQuota(employeeExternalHoursQuota.data.data);
      setClientOfficeHoursQuota(
        employeeClientOfficeHoursQuota.isError === false
          ? employeeClientOfficeHoursQuota.data.data
          : [],
      );
      setWorkTravelHoursQuota(
        employeeWorkTravelHoursQuota.isError === false
          ? employeeWorkTravelHoursQuota.data.data
          : [],
      );
      setQuotaLoader(false);
    }
  }, [selectedYear]);

  const getQuarterDateRange = (year, quarter) => {
    const ranges = {
      0: [`${year}-01-01`, `${year}-03-31`],
      1: [`${year}-04-01`, `${year}-06-30`],
      2: [`${year}-07-01`, `${year}-09-30`],
      3: [`${year}-10-01`, `${year}-12-31`],
    };
    return ranges[quarter];
  };

  const displaySummary = async () => {
    setPayrollLoader(true);
    const summaryData = await getSummary(startDate, endDate, currentUserId());
    const currentQuarterIndex = Math.floor(new Date(startDate).getMonth() / 3);
    const [quarterStart, quarterEnd] = getQuarterDateRange(
      new Date(startDate).getFullYear(),
      currentQuarterIndex,
    );
    const quarterSummaryData = await getSummary(
      quarterStart,
      quarterEnd,
      currentUserId(),
    );
    const allWFHTasks = await getWFHTask(currentUserId());
    const allRemoteOfficeTasks = await getRemoteOfficeHoursTasks(
      currentUserId(),
      { startDate, endDate },
      0,
      1000,
    );
    if (
      summaryData.isError === false &&
      quarterSummaryData.isError === false &&
      allWFHTasks.isError === false
    ) {
      const tasks = allWFHTasks?.data?.data?.content || [];
      const filteredTasks = tasks.filter((task) => {
        const taskDate = new Date(task.dateOfWfh);
        return taskDate >= new Date(startDate) && taskDate <= new Date(endDate);
      });

      const totalRequestedWfhHours = filteredTasks.reduce(
        (sum, task) => sum + (task.requestedWfhHours || 0),
        0,
      );

      const remoteTasks =
        allRemoteOfficeTasks?.isError === false
          ? allRemoteOfficeTasks?.data?.data?.content || []
          : [];
      const pendingRemoteSeconds = remoteTasks
        .filter((task) => task.status === 'PENDING')
        .reduce(
          (sum, task) => sum + (task.requestedRemoteOfficeHours || 0),
          0,
        );

      setReportedWfhHours(msToTime(totalRequestedWfhHours * 1000));
      setApprovedWfhHours(msToTime(summaryData.data.totalWfhHours || 0));
      setPendingRemoteOfficeHours(msToTime(pendingRemoteSeconds * 1000));
      setApprovedRemoteOfficeHours(
        msToTime(summaryData.data.totalRemoteOfficeHours || 0),
      );
      setOfficeHours(msToTime(summaryData.data.totalOfficeHours));
      setExternalHours(msToTime(summaryData.data.totalExternalHours));
      setClientOfficeHours(
        msToTime(summaryData.data.totalClientOfficeHours || 0),
      );
      setWorkTravelHours(
        msToTime(summaryData.data.totalWorkTravelHours || 0),
      );
      setWeekendWorkingHours(
        msToTime(summaryData.data.totalWeekendWorkingHours || 0),
      );
      setWfhDays(getDaysFromNumber(quarterSummaryData.data.workFromHomeDays));
      setTotalHours(
        msToTime(
          summaryData.data.totalHours > summaryData.data.expectedHours
            ? summaryData.data.expectedHours
            : summaryData.data.totalHours,
        ),
      );
      setExpectedHours(
        msToTime(
          summaryData.data.expectedHours > 0
            ? summaryData.data.expectedHours
            : 0,
        ),
      );
      setPayrollPercentage(
        summaryData.data.totalHours > summaryData.data.expectedHours
          ? 100
          : parseFloat(
              (
                (summaryData.data.totalHours / summaryData.data.expectedHours) *
                100
              ).toFixed(2),
            ),
      );
      setPayrollLoader(false);
    }
    setLoader(false);
    if (summaryData.status === '404') {
      setPayrollLoader(false);
    }
  };

  const getLeavesList = async () => {
    const year = new Date().getFullYear();
    const leaveType = await getLeaveTypeList(year);
    let userLeaves;
    let employeeId;

    if (people.id === '' && currentUserId() !== undefined) {
      employeeId = currentUserId();
    } else {
      employeeId = people.id;
    }

    userLeaves = await getUserLeaves(employeeId, {
      status: 'APPROVED',
      startDate: startDate,
      endDate: endDate,
    });
    const userData = await getUserData(
      people.id === '' ? currentUserId() : people.id,
    );
    let holidayDates = [];
    if (userData.data.locationId !== null) {
      const holidayList = await getHolidays(
        userData?.data?.locationId,
        startDate,
        new Date(
          startDate.slice(0, 4),
          startDate.slice(5, 7),
          0,
        ).toLocaleDateString('en-CA'),
      );
      holidayDates = holidayList?.data?.map((holiday) => holiday.date);
    }
    const leaveTypeWithCounts = leaveType?.data?.map((leaveType) => {
      const leaveId = leaveType.id;
      const applicationCount = userLeaves?.data?.data?.content
        .filter((application) => application.leaveId === leaveId)
        .reduce((total, application) => {
          const days = calculateLeaveDays(
            application.startDate < startDate
              ? startDate
              : application.startDate,
            application.endDate > endDate ? endDate : application.endDate,
            holidayDates,
          );
          return total + days;
        }, 0);

      return {
        ...leaveType,
        applicationCount,
      };
    });
    if (userLeaves.isError === false) {
      setUserAvailedLeaves(leaveTypeWithCounts);
    }
  };

  const calculateLeaveDays = (startDate, endDate, holidayList) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    let leaveDays = 0;

    while (start <= end) {
      const isWeekend = start.getDay() === 0 || start.getDay() === 6;
      const isHoliday = holidayList?.includes(
        start.toISOString().split('T')[0],
      );

      if (!isWeekend && !isHoliday) {
        leaveDays += 1;
      }

      start.setDate(start.getDate() + 1);
    }

    return leaveDays;
  };

  const onNavigate = (action, date = currentDate) => {
    let start, end, newDate;
    switch (action) {
      case 'PREV':
        newDate = moment(currentDate).subtract(1, 'month').toDate();
        break;
      case 'NEXT':
        newDate = moment(currentDate).add(1, 'month').toDate();
        break;
      case 'DATE':
        newDate = date instanceof Date ? date : new Date(date);
        break;
      default:
        newDate = currentDate;
    }

    start = new Date(
      newDate.getFullYear(),
      newDate.getMonth(),
      1,
    ).toLocaleDateString('en-CA');
    end = new Date(
      newDate.getFullYear(),
      newDate.getMonth() + 1,
      0,
    ).toLocaleDateString('en-CA');
    setCurrentDate(newDate);

    setStartDate(start);
    setEndDate(start === dt ? moment(new Date()).format('YYYY-MM-DD') : end);
  };

  useEffect(() => {
    loadData();
  }, [people]);

  useEffect(() => {
    displaySummary();
    getLeavesList();
    setSelectedYear(new Date(startDate).getFullYear());
  }, [startDate, endDate]);

  //Oct 1 2023 dashboard changes
  return (
    <>
      <Grid container justifyContent={'space-evenly'}>
        <Grid
          item
          xs={12}
          md={5.95}
          sx={{ display: 'flex', flexDirection: 'column' }}
        >
          <Box className={classes.nameTile}>
            <Welcome userDetails={userDetails} />
          </Box>
        </Grid>
        <Grid item xs={12} md={5.95}>
          <Box className={classes.dateTile}>
            <TimingsDetail userDetails={userDetails} />
          </Box>
        </Grid>
      </Grid>
      <Grid container justifyContent={'space-evenly'}>
        <Grid
          item
          xs={12}
          md={5.95}
          sx={{ display: 'flex', flexDirection: 'column' }}
        >
          <Box className={classes.dateTile} mt={0.5}>
            {quotaLoader ? (
              <GenericLoader
                rectAttributes={TimesheetsComponentLoaderAttribute}
                width={'100%'}
                height={290}
              />
            ) : (
              <QuotaDetails
                startDate={startDate}
                wfhQuota={wfhQuota}
                wfhDays={wfhDays}
                externalHoursQuota={externalHoursQuota}
                externalHours={externalHours}
                clientOfficeHoursQuota={clientOfficeHoursQuota}
                clientOfficeHours={clientOfficeHours}
                workTravelHoursQuota={workTravelHoursQuota}
                workTravelHours={workTravelHours}
                leaveQuota={filteredLeaveList}
                casualLeaveAccounting={casualLeaveAccounting}
              />
            )}
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={5.95}
          sx={{ display: 'flex', flexDirection: 'column' }}
        >
          <Box className={classes.workPayrollTile} my={0.5}>
            <WorkPayrollSummary
              loader={payrollLoader}
              onNavigate={onNavigate}
              totalHours={totalHours}
              officeHours={officeHours}
              reportedWfhHours={reportedWfhHours}
              approvedWfhHours={approvedWfhHours}
              pendingRemoteOfficeHours={pendingRemoteOfficeHours}
              approvedRemoteOfficeHours={approvedRemoteOfficeHours}
              externalHours={externalHours}
              clientOfficeHours={clientOfficeHours}
              workTravelHours={workTravelHours}
              weekendWorkingHours={weekendWorkingHours}
              expectedHours={expectedHours}
              payrollPercentage={payrollPercentage}
              leavesAvailed={userAvailedLeaves}
              label={moment(currentDate).format('MMMM YYYY')}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );

  //Old dashboard look
  // return (
  //   <>
  //     <Grid
  //       item
  //       xs={6}
  //       sx={{ justifyContent: 'space-between' }}
  //       container
  //       // columns={{ xs: 6, md: 6 }}
  //       // rowSpacing={4}
  //     >
  //       <Grid
  //         item
  //         md={12}
  //         // sm={1.4}
  //         xs={12}
  //         sx={{ margin: '5px' }}
  //         className={classes.nameTile}
  //       >
  //         <Welcome userDetails={userDetails} />
  //       </Grid>
  //       <Grid
  //         item
  //         md={12}
  //         // sm={1.4}
  //         xs={12}
  //         sx={{ margin: '5px' }}
  //         className={classes.dateTile}
  //       >
  //         <TimingsDetail userDetails={userDetails} />
  //       </Grid>
  //     </Grid>
  //     <Grid
  //       item
  //       xs={6}
  //       sx={{ justifyContent: 'space-between' }}
  //       container
  //       // columns={{ xs: 6, md: 6 }}
  //       // rowSpacing={4}
  //     >
  //       <Grid
  //         item
  //         md={12}
  //         // sm={1.4}
  //         xs={12}
  //         sx={{ margin: '5px' }}
  //         className={classes.leaveTile}
  //       >
  //         <LeaveStatus
  //           managerList={managerList}
  //           leaveStatus={leaveStatus}
  //           overallStatus={overallStatus}
  //           leaveDate={leaveDate}
  //         />
  //       </Grid>
  //       <Grid
  //         item
  //         md={12}
  //         // sm={1.4}
  //         xs={12}
  //         sx={{ margin: '5px', maxHeight: 'auto', overflowY: 'auto' }}
  //         className={classes.dateTile}
  //       >
  //         <PeopleOnLeave employeesOnLeave={employeesOnLeave} />
  //       </Grid>
  //     </Grid>
  //   </>
  // );
}

export default Tiles;
